module.exports = __webpack_public_path__ + "img/XMY.43f18ac0.svg";